import { useMemo } from 'react';

import { GET_CLEARANCE_DATA } from 'mocks/queries';
import useZipCode from 'global-state/zipCode/useZipCode';
import useWarehouseIdForUser from 'global-state/warehouseIdForUser/useWarehouseIdForUser';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { DEFAULT_WAREHOUSE_ID } from 'commons/constants';
import useIsBrowser from 'hooks/useIsBrowser';

const DEFAULT_VARIABLES = {
  zipCode: '',
  fromCache: true,
  warehouseId: DEFAULT_WAREHOUSE_ID,
};

/* Gives all clearance stock (multiple products) for the user's zipcode
 * skipQuery - Allows skipping clearance stock fetch when used conditionally
 */
const useAllProductClearanceStock = (skipQuery = false) => {
  const zipCode = useZipCode();
  const isBrowser = useIsBrowser();
  const warehouseId = useWarehouseIdForUser();

  const { loading, data } = useSuspenseQuery(GET_CLEARANCE_DATA, {
    variables: isBrowser
      ? { zipCode, fromCache: true, warehouseId }
      : DEFAULT_VARIABLES,
    skip: skipQuery,
  });

  const clearanceData = useMemo(() => data?.clearanceData?.data || {}, [
    data?.clearanceData?.data,
  ]);

  return {
    data: clearanceData,
    error: null,
    loading: loading && !data,
  };
};

export default useAllProductClearanceStock;
